import { render } from "./ByosTagsAndRibbons.vue?vue&type=template&id=892d17a4"
import script from "./ByosTagsAndRibbons.vue?vue&type=script&setup=true&lang=js"
export * from "./ByosTagsAndRibbons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/byos/ByosTagsAndRibbons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "892d17a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('892d17a4', __exports__)) {
    api.reload('892d17a4', __exports__)
  }
  
  module.hot.accept("./ByosTagsAndRibbons.vue?vue&type=template&id=892d17a4", () => {
    api.rerender('892d17a4', render)
  })

}


export default __exports__